module.exports = __webpack_public_path__ + "static/media/chevron-down-black.bc3b734a.svg";